import Icon from './Icon';

const images = require.context('./../Assets/Icons', true);
const iconsList = images.keys().map(image => images(image));

const Icons = () => {
    // https://www.iconfinder.com/
    const icons_arr = ['Github','Email','Linkedin','Medium','Resume']
    return (
        <div className='icons mb-4 bg-body-tertiary rounded-3'>
            <div className='row icons-container'>
                {
                    icons_arr.map((value, index) => 
                        <Icon icon={iconsList[index]} text={value} ></Icon>
                    )
                }
 
            </div>
            
        </div>
    )
}

export default Icons;